import { FormControl } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useState, useEffect } from "react";

const PhoneTextField = ({
  value,
  onChange,
  label = "Số điện thoại",
  name = "phone",
  required = false,
  disabled = false,
}) => {
  const id = `${name}-input`;

  const [isFocused, setIsFocused] = useState(false);
  const hasError = required && value.trim() === "";

  // Decide label color based on state
  const labelColor = hasError ? "#f44336" : isFocused ? "#3f51b5" : "rgba(0, 0, 0, 0.6)";

  return (
    <FormControl fullWidth>
      <PhoneInput
        country="vn"
        value={value}
        onChange={(phoneValue, countryData) => {
          onChange(phoneValue, countryData);
        }}
        placeholder=" "
        inputProps={{
          name,
          id,
          disabled,
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
        }}
        containerStyle={{
          width: "100%",
          position: "relative",
        }}
        inputStyle={{
          width: "100%",
          height: "56px",
          paddingLeft: "48px",
          fontSize: "1rem",
          border: `1px solid ${hasError ? "#f44336" : "#c4c4c4"}`,
          borderRadius: "4px",
          backgroundColor: disabled ? "#f5f5f5" : "white",
        }}
        buttonStyle={{
          border: "none",
          backgroundColor: "transparent",
        }}
      />

      <label
        htmlFor={id}
        style={{
          position: "absolute",
          top: "-8px",
          left: "12px",
          background: "white",
          padding: "0 4px",
          fontSize: "12px",
          color: labelColor,
          pointerEvents: "none",
        }}
      >
        {label}
        {required && " *"}
      </label>
    </FormControl>
  );
};

export default PhoneTextField;
